<section>
  <h1>Ballistic Evidence</h1>
  <p-tabView #tabVw (onChange)="onChangeTab($event)">
    <p-tabPanel header="Search" [selected]="index == 0" [cache]="true">
      <ng-template pTemplate="content">
        <ness-search></ness-search> 
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="List" [selected]="index == 1"  [cache]="true">
      <ng-template pTemplate="header">List&nbsp;</ng-template>
      <ng-template pTemplate="content">
        <ness-ballistic-evidence-list></ness-ballistic-evidence-list>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</section>
